export const PROJECTS =
    [
        {
            id: 1,
            name:'Car Dealership Application',
            year:'Sep 2020',
            description:'The Car Dealership Application a salesforce-based application for the management of different car models. The application is made using the tools such as process builder, approval process, provided by salesforce with UI built using Lightning Web Components Framework.',
            links: ['https://github.com/mohit2308jain/Car-Manufacturing-Salesforce'],
            labels: ['Github Link']
        },
        {
            id: 2,
            name:'Certification Management Application',
            year:'Apr 2020',
            description:'The Certification Management Application is a salesforce-based application for the management of certifications and vouchers. The application is made using the tools such as process builder, approval process, apex triggers provided by salesforce.',
            links: ['https://github.com/mohit2308jain/Certificate-Management-LWC'],
            labels: ['Github Link']
        },
        {
            id: 3,
            name:'Expenser',
            year:'July 2020',
            description:'An expense manager app build using React for front-end, PostgreSQL for database, and Node and Express for the back-end of the web app. The User can add, update, delete the expenses. Also, the app is incorporated with charts for the analysis of expenses.',
            links: ['https://expenser-react.vercel.app'],
            labels: ['See Project']
        },
        {
            id: 3,
            name:'TodoList',
            year:'May 2020',
            description:'A Todo web app built using React for front-end, MongoDB for database, Node, and Express for the back-end of the web app. The User can add the task with the category, due date, and remarks for the task. The User can also delete a particular task and mark the task as completed.',
            links: ['https://todolist-react.vercel.app'],
            labels: ['See Project']
        },
        {
            id: 5,
            name:'Movies, Books, Food - All In One',
            year:'June 2020',
            description:'The web app allows users to search for their favorite movies, books, and food along with the weather information for the location of their preference. The app uses different public APIs for providing information to users. The app is built using both React and Angular as different versions of the app.',
            links: ['https://allinone-react.vercel.app', 'https://allinone-angular.vercel.app'],
            labels: ['React Link', 'Angular Link']
        },
        {
            id: 6,
            name:'Like Youtube',
            year:'June 2020',
            description:'A single page web app clone of youtube video page. The app is built using React, Redux and Reactstrap is used for styling the web app along with youtube data API.',
            links: ['http://like-yt-react.vercel.app/'],
            labels: ['See Project']
        }
    ];
